"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var prefix = 'tk-button';
exports.Button = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, iconButton = _a.iconButton, variant = _a.variant, loading = _a.loading, disabled = _a.disabled, type = _a.type, size = _a.size, iconRight = _a.iconRight, iconLeft = _a.iconLeft, rest = __rest(_a, ["children", "className", "iconButton", "variant", "loading", "disabled", "type", "size", "iconRight", "iconLeft"]);
    var classes = classnames_1.default(className, prefix, prefix + "--" + variant, prefix + "--" + size, (_b = {}, _b[prefix + "--icon"] = iconButton, _b['loading'] = loading, _b[prefix + "--icon-left"] = iconLeft, _b[prefix + "--icon-right"] = iconRight, _b));
    if (variant === 'destructive') {
        console.warn('The button variant: \'destructive\' will be deprecated.\n Please use: \'primary-destructive\' instead');
    }
    return (React.createElement("button", __assign({ "aria-label": loading ? 'loading' : null, className: classes, disabled: loading || disabled, style: { color: loading ? 'transparent' : null }, 
        /* eslint-disable react/button-has-type */
        type: type }, rest),
        loading && React.createElement("i", { className: "tk-button-icon--loading animate-spin tk-icon-loading" }),
        iconLeft,
        children,
        iconRight));
};
exports.Button.defaultProps = {
    iconButton: false,
    className: '',
    disabled: false,
    loading: false,
    type: 'button',
    variant: 'primary',
    size: 'medium',
};
exports.Button.propTypes = {
    iconButton: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'reset', 'submit']),
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'destructive', 'primary-destructive', 'secondary-destructive', 'tertiary-destructive', 'tertiary-accent']),
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['small', 'large', 'medium']),
    iconLeft: PropTypes.node,
    iconRight: PropTypes.node,
};
exports.Button.displayName = 'Button';
exports.default = exports.Button;
